<template>
  <!-- 发起新抵扣条目
    type === 'deduct'
    issued_type === 2 开票类别 预收款开票
    status === 7 状态 已签收
    issued_type === user.id  发起人 是当前登录用户
    available_deduct_amount ！== 0 可用抵扣金额 -->
  <div>
    <el-tooltip class="item"
                effect="dark"
                content='在预收款开票申请时可以同时添加该预收款的抵扣申请，抵扣申请将于开票状态变为已签收时生效'
                placement="right">
      <el-button type="danger"
                 size="mini"
                 @click="onAddDeductionDetail()"
                 style="margin-left:30px; margin-bottom: 30px">添加抵扣申请
      </el-button>
    </el-tooltip>
    <el-row :hidden="deductList.length === 0">
      <el-col :span="1"
              class="col-center">序号
      </el-col>
      <el-col :span="6"
              class="col-center">项目名称/编号
      </el-col>
      <el-col :span="6"
              class="col-center">抵扣含税金额
      </el-col>
    </el-row>
    <br/>
    <el-row v-for="(detailItem, itemIndex) in deductList"
            :key="itemIndex"
            class="invoice-row"
            style="margin-top:5px">
      <!--序号-->
      <el-col style="text-align: center"
              :span="1">
        {{ itemIndex + 1 }}
      </el-col>
      <!--项目名称/编号-->
      <el-col :span="6">
        <remote-select
          :disabled="isDeductionItemDisabled(detailItem) || !form.customerid"
          class="width-max"
          clearable
          id-key="number"
          label-key="name"
          value-key="id"
          placeholder="请输入项目名称/编号搜索"
          v-model="detailItem.project_id"
          :query-request="(_)=>getProjectTable(Object.assign({status: statusEnum.ACHIEVEMENT, customerid: form.customerid}, _))"
          :find-request="getProjectDetail">
        </remote-select>
      </el-col>
      <el-col :span="0.8">&nbsp;&nbsp;&nbsp;&nbsp;</el-col>
      <!--抵扣含税金额-->
      <el-col :span="6"
              style="text-align:center">
        <el-input v-model="detailItem.deduction_amount"
                  :disabled="isDeductionItemDisabled(detailItem)"
                  placeholder="请输入抵扣含税金额"
                  @input=""
        ></el-input>
      </el-col>
      <el-col :span="0.8">&nbsp;&nbsp;&nbsp;&nbsp;</el-col>
      <el-col :span="5">
        <el-upload
          :disabled="isDeductionItemDisabled(detailItem)"
          class="upload-demo"
          action=""
          :auto-upload="false"
          :on-change="(file, fileList) => {onChangeFile(file, fileList, deductList[itemIndex].attached_file)}"
          :before-remove="(file, fileList) => {beforeRemove(file, fileList, deductList[itemIndex].attached_file)}"
          multiple
          :limit="5"
          :on-exceed="(file, fileList) => {handleExceed(file, fileList, 5)}"
          :file-list="deductList[itemIndex].attached_file"
          ref="upload"
          accept=".jpg, .jpeg, .png, .pdf, .eml"
        >
          <el-tooltip class="item"
                      effect="dark"
                      content="只能上传PNG/JPG/PDF/EML文件，允许上传多张"
                      placement="right">
            <el-button size="small"
                       :disabled="isDeductionItemDisabled(detailItem)"
                       type="primary">上传抵扣审批附件
            </el-button>
          </el-tooltip>
        </el-upload>
      </el-col>
      <el-col :span="0.8">&nbsp;&nbsp;&nbsp;&nbsp;</el-col>
      <el-col :span=3>
        <el-row style="margin-bottom: 5px">
          <!--  只有待审批的抵扣条目允许删除  -->
          <el-button type="danger"
                     :disabled="isDeductionItemDisabled(detailItem)"
                     style="display: block"
                     size="mini"
                     icon="el-icon-delete"
                     @click="onDelDeductionItem(itemIndex)">删除
          </el-button>
        </el-row>
      </el-col>
    </el-row>

    <div style="margin:0 auto; text-align:right;">
      <el-button @click="$router.back()">取消</el-button>
      <el-button type="primary"
                 @click="onSubmit()">保存
      </el-button>
    </div>
  </div>
</template>

<script>
import { regType } from '@utils/regExp'

export default {
  props: {
    form: {
      type: Object,
      default: () => {},
    },
  },
  created () {
    // 获取抵扣条目附件访问链接, 避免新增抵扣时详情部分新增，使用新变量存储数据
    this.deductList = JSON.parse(JSON.stringify(this.form.deduction_detail))
  },
  data () {
    return {
      deductList: [],
    }
  },
  methods: {
    ...Vuex.mapActions(['getProjectTable', 'getProjectDetail']),
    ...Vuex.mapState({
      statusEnum: state => state.customerProjectcost.statusEnum,
    }),
    isDeductionItemDisabled (detailItem) {
      // 抵扣条目的状态见 deduction_detail_status 数组,条目处于非待审核状态时，禁用编辑删除功能
      return detailItem.status && detailItem.status * 1 !== 1
    },
    onSubmit () {
      if (this.checkSubmit()) {
        this.updateReceiptDeductList()
      }
    },
    getFormDeductionDetail () {
      return filter.copyJson(this.deductList)
    },
    onAddDeductionDetail () {
      let params = {
        project_id: '',
        project: {'name': '', 'number': ''},
        deduction_amount: 0,
        attached_file: [],
      }
      this.deductList.push(params)
    },
    onDelDeductionItem (index) {
      this.deductList.splice(index, 1)
    },
    checkSubmit () {
      let deductionTaxedAmountTotal = 0
      for (let i = 0; i < this.deductList.length; i++) {
        if (!this.deductList[i].project_id) {
          this.$message.error('请选择抵扣申请项目')
          return false
        }
        if (!regType('money').test(Math.abs(this.deductList[i].deduction_amount)) || Math.abs(this.deductList[i].deduction_amount) === 0) {
          this.$message.error('请输入正确的抵扣申请含税金额')
          return false
        }
        if (this.deductList[i].attached_file.length < 1) {
          this.$message.error('请上传抵扣申请附件')
          return false
        }
        if (!this.deductList[i].status || [1, 2, 3].includes(this.deductList[i].status * 1)) {
          deductionTaxedAmountTotal += Number(this.deductList[i].deduction_amount)
        }
        delete this.deductList[i].log
      }
      if (Math.abs(deductionTaxedAmountTotal) > Math.abs(this.taxed_total_amount)) {
        this.$message.error('抵扣金额总和不得大于价税合计总计金额')
        return false
      }
      return true
    },
    updateReceiptDeductList () {
      request.common('updateReceiptDeductList', {
        id: this.$route.params.id,
        deduction_detail: this.getFormDeductionDetail()
      }).then((res) => {
        this.$confirm('抵扣申请提交成功, 是否前往列表页面？', '提示', {type: 'success'}).then(() => {
          this.$router.push('/invoice-apply/table')
        }).catch(() => {
          this.$router.go(0)
        })
      })
    },
    handleExceed (files, fileList, max) {
      this.$message.warning(`当前限制选择 ${max} 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    },
    onChangeFile (file, fileList, formField) {
      let isLt10M = file.raw.size / 1024 / 1024 < 10
      if (!isLt10M) {
        this.$message.error('大小不能超过10MB!')
        this.$refs.upload.clearFiles()
        return false
      }
      this.onUploadFile(file.raw, fileList, formField)
    },
    onUploadFile (file, fileList, formField) {
      let formData = new FormData()
      formData.append('file', file)
      return request.alert('uploadInvoiceApplyFile', formData).then(({data}) => {
        this.$message({
          showClose: true,
          message: '上传成功',
          type: 'success',
        })
        let index = this.getFileListIndex(file, fileList)

        let type
        if ((file.name.substr(-5).toLowerCase() === '.jpeg') || (file.name.substr(-4).toLowerCase() === '.jpg') || (file.name.substr(-4).toLowerCase() === '.png')) {
          type = 'pic'
        } else if (file.name.substr(-4).toLowerCase() === '.pdf') {
          type = 'pdf'
        } else if (file.name.substr(-4).toLowerCase() === '.eml') {
          type = 'eml'
        } else if (file.name.substr(-5).toLowerCase() === '.docx' || (file.name.substr(-5).toLowerCase() === '.xlsx') || (file.name.substr(-4).toLowerCase() === '.doc')) {
          type = 'office'
        }
        if (index > -1) {
          fileList[index].status = 'success'
          formField[index] = {name: file.name, url: data, type: type}
        }
      }).catch(_ => {
        this.$refs.upload.uploadFiles.pop()
      })
    },
    getFileListIndex (file, fileList) {
      for (let i = 0; i < fileList.length; i++) {
        let fileTemp
        if (fileList[i].raw) {
          fileTemp = fileList[i].raw
        } else {
          fileTemp = fileList[i]
        }
        if (file === fileTemp) {
          return i
        }
      }
      return -1
    },
    beforeRemove (file, fileList, formField) {
      let fileTemp
      if (file.raw) {
        fileTemp = file.raw
      } else {
        fileTemp = file
      }
      let index = this.getFileListIndex(fileTemp, fileList)
      if (index > -1) {
        formField.splice(index, 1)
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/invoice-apply/components/InvoiceDeductApplyForm.vue